export const MOMENT_UNIT = {
  MINUTE: 'minutes',
  DAY: 'day',
};
